import {WithdrawChooseOption} from "./loveStoryConst";
import {getOnePeopleById} from "../../config/WeChatPeopleConfig";
import getOneBundle, {BUNDLE_SMALL_NAME} from "../../BundleResourceConfig";
import O1HD from "../../../../engines/gameEngine";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

/**
 * 提现结果 预制体
 */
@ccclass
export default class WithdrawResultPrefab extends cc.Component {

    @property({type:cc.Sprite,displayName:"头像"})
    spNode : cc.Sprite = null;
    @property({type:cc.Label,displayName:"描述"})
    lbDesc : cc.Label = null;
    @property({type:cc.Label,displayName:"女生名称"})
    lbGirlName : cc.Label = null;
    @property({type:cc.Node ,displayName:" 通过节点"})
    accessNode : cc.Node = null;
    @property({type:cc.Node ,displayName:" 拒绝"})
    refuseNode : cc.Node = null;

    mWithdrawChoose : WithdrawChooseOption;

    @property({type:cc.Node,displayName:"中心动画节点"})
    centerNode:cc.Node = null;

    onLoad () {
        this.centerNode.scale = 0;
        cc.tween(this.centerNode).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
    }

    start () {

    }

    /**
     * 绑定数据
     * @param withdrawChoose
     */
    async bindData( withdrawChoose : WithdrawChooseOption ,addCoin : number = null ){
        this.mWithdrawChoose = withdrawChoose;
        let people = getOnePeopleById( this.mWithdrawChoose.peopleId );
        let headUrl : string = people.headUrl;
        let bundle = await getOneBundle(BUNDLE_SMALL_NAME.WeChatGameBundle);
        bundle.load( headUrl,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.log("加载头像失败 # loveStoryShareItem",err);
                return;
            }
            this.spNode.spriteFrame = spr;
        });
        this.lbGirlName.string = `${this.mWithdrawChoose.peopleId}`;
        this.lbDesc.string = `${this.mWithdrawChoose.withdrawReplayContent}`;

        //如果是同意的 添加金钱
        if ( this.mWithdrawChoose.withdrawSuccessFlag ) {
            O1HD.getServices().userSrv.setCoins( -addCoin , true , this.lbDesc.node );
            this.accessNode.active = true;
        }else {
            this.refuseNode.active = true;
        }

    }

    /**
     * 知道了
     */
    onBtnMakeSure(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._close();
    }

    /**
     *
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._close();
    }

    private _close(){
        this.node.removeFromParent();
        this.node.destroy();
    }
}
